export * from './Intl/main';
export * from './Localization/main';
export * from './coreExports';
export * from './intlUtils';



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-intl/dist/es/main.js
// module id = 22
// module chunks = 93